module.exports = __webpack_public_path__ + "img/260720945_1_10.c0bbb5b7.png";